import { css, keyframes } from '@emotion/react';
import { ButtonDesign, ButtonSize, ButtonStyle } from 'components/buttons/ButtonStyle';
import {
  CommonBG,
  CommonBorder,
  CommonText,
  ControlLinedBG,
  ControlLinedBorder,
  PrimaryColor,
} from 'ui/theme/Color';

export const underline = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

export const tabs = {
  tab: css`
    min-height: 0px !important;
    height: 36px !important;
    overflow: visible !important;
    margin-bottom: 16px;
    .MuiTabs-scroller {
      overflow: visible !important;
    }
    .MuiTabs-scroller {
      min-height: 0px !important;
      height: 36px !important;
      border-bottom: 1px solid ${CommonBorder.Strong};
    }
    .MuiButtonBase-root {
      font-size: 13px;
      color: ${CommonText.Light};
      font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', sans-serif;
      min-width: 0px !important;
      min-height: 0px !important;
      height: 36px !important;
      padding: 8px 12px;
      border: 1px solid ${CommonBorder.Strong};
      background: ${CommonBG.Deeper};
      & + .MuiButtonBase-root {
        border-left: none;
      }
      &:hover {
        background: ${CommonBG.Basic};
        color: ${CommonText.Primary} !important;
      }
      &:disabled {
        color: ${CommonText.Lighter};
        pointer-events: none;
      }
    }
    .tab-bg {
      background: #fff8cd80;
    }
    .Mui-selected {
      background: ${CommonBG.Basic};
      color: ${CommonText.Primary} !important;
    }
    .MuiTabs-indicator {
      z-index: 999;
      bottom: -2px !important;
      height: 2px !important;
      background: ${CommonBorder.inverse} !important;
    }
  `,
  subtab: css`
    min-height: 0px !important;
    height: 32px !important;
    margin-bottom: 16px;
    .MuiButtonBase-root {
      font-size: 13px;
      color: ${CommonText.Light};
      font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', sans-serif;
      min-width: 0px !important;
      min-height: 0px !important;
      height: 32px !important;
      padding: 6px 10px;
      & + .MuiButtonBase-root {
        margin-left: 8px;
      }
      /* &:hover {
        color: ${CommonText.Primary};
      } */
      &:disabled {
        color: ${CommonText.Lighter};
        pointer-events: none;
      }
    }

    .hasData,
    .noData {
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        width: 0;
      }
      &.Mui-selected::after {
        animation: ${underline} 0.2s ease-out forwards;
      }
    }
    .hasData {
      color: ${CommonText.Primary} !important;
      background: ${PrimaryColor.Primary100};
      &:hover {
        background: ${PrimaryColor.Primary200};
      }
      &.Mui-selected {
        background: ${PrimaryColor.Primary200};
        color: ${CommonText.Primary} !important;
        &::after {
          background-color: ${CommonBG.Primary};
        }
      }
    }
    .noData {
      background: ${CommonBG.Deeper};
      &:hover {
        background: ${CommonBG.Stonger};
      }
      &.Mui-selected {
        background: ${CommonBG.Stonger};
        &::after {
          background-color: ${CommonBG.Dim};
        }
      }
    }

    .MuiTabs-indicator {
      display: none;
      /* background:${ControlLinedBorder.PrimaryActive}; */
    }
  `,
  anotherTab: css`
    display: flex;
    min-height: 20px;
    border: 1px solid ${CommonBorder.Basic};
    border-right: none;
    button {
      min-width: auto;
      min-height: 20px;
      padding: 6px;
      font-size: 12px;
      flex-grow: 1;
      font-weight: 400;
      border-right: 1px solid ${CommonBorder.Basic};
      em {
        font-weight: 600;
        color: ${CommonText.Basic};
      }
      &:hover:not(.Mui-selected) {
        background: ${CommonBG.Deeper};
      }
    }

    .Mui-selected {
      background: ${PrimaryColor.Primary100};
      color: ${CommonText.Primary} !important;
      em {
        color: ${CommonText.Primary};
      }
    }
  `,
  wrap: css`
    position: relative;
    margin-bottom: 16px;
    button {
      &.btnFold {
        ${ButtonDesign.IconMD}
        width: 28px !important;
        min-width: 28px !important;
        &:active,
        &.active {
          transform: rotate(180deg);
        }
        &.active {
          transform: rotate(180deg);
        }
      }
    }
  `,
  btn: css`
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    label {
      margin-right: 4px;
      font-size: 12px;
    }
    div {
      padding-left: 2px;
      height: 28px;
      & + button {
        margin-left: 4px;
      }
      input {
        height: 100%;
      }
    }
    button {
      ${ButtonSize.sm}
      ${ButtonDesign.IconLfSM};
      ${ButtonStyle.outlineNormal}
      &.ok, &.save, &.confirm {
        ${ButtonStyle.containedPrimary}
      }
    }
    button + button {
      margin-left: 4px;
    }
  `,
};
